
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function About() {
  const navigate = useNavigate();

  const team = [
    {
      name: 'Michael Okpechi',
      role: 'Founder & Developer of PitchMe.AI',
      image: "https://res.cloudinary.com/dwwzrtzb8/image/upload/v1760420310/IMG_0350_tjzynv.jpg",
      bio: 'Software engineer with a passion for AI and career development. Built PitchMe.AI to help professionals practice interviews with AI-driven feedback.'
    },
    {
      name: 'Daniel Okpechi',
      role: 'Lead Designer of PitchMe.AI',
      image: "https://res.cloudinary.com/dwwzrtzb8/image/upload/v1760419973/IMG_0841_ckovca.jpg",
      bio: 'As the Lead Designer, I focused on creating an intuitive and engaging user experience that makes interview practice seamless.'
    },

  ];

  const values = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'We continuously push the boundaries of AI technology to create better interview experiences.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Empathy',
      description: 'We understand job searching is stressful and design our platform with compassion and care.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trust',
      description: 'We maintain the highest standards of privacy and security for all user interactions.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Excellence',
      description: 'We strive for perfection in every feature, ensuring our users get the best possible experience.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div
              className="flex items-center cursor-pointer"
              onClick={() => navigate('/')}
            >
              <div className="w-10 h-10 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-robot-line text-xl text-white"></i>
              </div>
              <h1 className="text-2xl font-bold text-gray-900">
                PitchMe.AI
              </h1>
            </div>
            <div className="flex items-center space-x-4">
              <Button variant="outline" onClick={() => navigate('/login')}>
                Sign In
              </Button>
              <Button onClick={() => navigate('/login')}>
                Get Started
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100 py-20">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-600/10 to-blue-600/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            About PitchMe.AI
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We're on a mission to democratize interview success by providing AI-powered practice
            tools that help professionals land their dream jobs with confidence.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Our Mission
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Job interviews can be nerve-wracking, and many talented individuals miss opportunities
                simply because they haven't had enough practice. We believe everyone deserves a fair
                chance to showcase their skills and potential.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                That's why we created PitchMe.AI - an intelligent platform that provides personalized
                interview practice, real-time feedback, and the confidence boost you need to succeed
                in any interview situation.
              </p>
            </div>
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20diverse%20team%20collaboration%20in%20bright%20office%20space%2C%20professionals%20working%20together%20on%20innovative%20AI%20technology%2C%20inclusive%20workplace%20environment%2C%20natural%20lighting%2C%20teamwork%20atmosphere&width=600&height=400&seq=mission&orientation=landscape"
                alt="Our Mission"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Values
            </h2>
            <p className="text-xl text-gray-600">
              The principles that guide everything we do
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <Card key={index} padding="lg" className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${value.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Meet Our Team
            </h2>
            <p className="text-xl text-gray-600">
              The passionate people behind PitchMe.AI
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-16">
            {team.map((member, index) => (
              <Card key={index} padding="lg" className="text-center">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-32 h-32 rounded-full mx-auto mb-6 object-cover"
                />
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {member.name}
                </h3>
                <p className="text-purple-600 font-medium mb-4">
                  {member.role}
                </p>
                <p className="text-gray-600 leading-relaxed">
                  {member.bio}
                </p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-blue-600">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-white mb-6">
            Our Story
          </h2>
          <p className="text-xl text-purple-100 mb-8 leading-relaxed">
            Founded in 2025 by two brothers from Nigeria during their Master’s programme in Computer Science at Coventry University,
            PitchMe.AI was born out of a shared determination to make a positive impact.
            What started as a vision to help job seekers practice and grow has evolved into a platform designed to empower professionals
            to excel in interviews with confidence.

          </p>
          {/* <Button
            size="lg"
            className="bg-white text-purple-600 hover:bg-purple-50 hover:text-purple-700 px-8"
            onClick={() => navigate('/login')}
          >
            Join Our Community
            <i className="ri-arrow-right-line ml-2"></i>
          </Button> */}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center mr-2">
                  <i className="ri-robot-line text-white"></i>
                </div>
                <h3 className="text-xl font-bold">
                  PitchMe.AI
                </h3>
              </div>
              <p className="text-gray-400">
                Master your interviews with AI-powered practice and feedback.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="/#features" className="hover:text-white">Features</a></li>
                <li><a href="/#pricing" className="hover:text-white">Pricing</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="/about" className="hover:text-white">About</a></li>
                <li><a href="/careers" className="hover:text-white">Careers</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-gray-400">
                {/* <li>
                  <button
                    onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                    className="hover:text-white text-left"
                  >
                    Help Center
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                    className="hover:text-white text-left"
                  >
                    Contact
                  </button>
                </li> */}
                <li><a href="/terms" className="hover:text-white">Terms</a></li>

                <li><a href="/privacy" className="hover:text-white">Privacy</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 flex justify-between items-center">
            <p className="text-gray-400">
              © 2025 PitchMe.AI. All rights reserved.
            </p>

          </div>
        </div>
      </footer>
    </div>
  );
}